var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"echart"},[_c('WaterEchart',{ref:"refEchart",staticClass:"echart__content",attrs:{"data":_vm.proportionData,"flag":888}}),_c('img',{attrs:{"src":_vm.useLevel(1)}}),_c('p',[_vm._v("风险等级")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }